import React from 'react'
import useEventCallback from '../../../utils/useEventCallback'
import TagActionButton from '../../../genericComponents/TagActionButton'
import { TAG_CLICK_USER_LOGOUT_BUTTON } from '../../../analytics/analytics.tagids.constants'
import { useSelector } from 'react-redux'
import { selectPrevFullRouteNonPageLess } from '../../../../store/history/history.selectors'
import useKeycloak from '../../useKeycloak'

const UserLogout = ({ children }) => {
  const { loaded, keycloak } = useKeycloak()
  const lastFullRoute = useSelector(selectPrevFullRouteNonPageLess)

  const onLogout = useEventCallback(() => {
    keycloak?.logout({ redirectUri: `${location.origin}${lastFullRoute}` })
  }, [loaded, keycloak, lastFullRoute])

  if (!loaded) return <></>

  return (
    <TagActionButton type={TAG_CLICK_USER_LOGOUT_BUTTON} onClick={onLogout} deferClick>
      {children}
    </TagActionButton>
  )
}

export default UserLogout
